<template>
  <div>
    <div class="flex gap-2 text-primary">
      <v-icon
        color="primary"
        :size="20">
        mdi-message
      </v-icon>
      <span class="text-xl font-medium">ตั้งค่าข้อความคำสั่งซื้อ</span>
    </div>
    <v-tabs
      v-model="tab"
      class="app-tab mt-6"
      show-arrows>
      <v-tab
        v-for="header in tabHeaders"
        :key="header.id"
        :href="`#${header.value}`">
        {{ header.title }}
      </v-tab>
    </v-tabs>
    <v-tabs-items
      v-model="tab">
      <v-tab-item
        value="send">
        <send-message />
      </v-tab-item>
      <v-tab-item
        value="auto-message">
        <auto-message />
      </v-tab-item>
      <v-tab-item
        value="message">
        <order-message />
      </v-tab-item>
      <v-tab-item
        value="cod">
        <cod-message />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import SendMessage from '@/views/Message/components/SendMessage.vue'
import AutoMessage from '@/views/Message/components/AutoMessage.vue'
import OrderMessage from '@/views/Message/components/OrderMessage.vue'
import CodMessage from '@/views/Message/components/CodMessage.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Message',
  components: {
    SendMessage,
    AutoMessage,
    OrderMessage,
    CodMessage
  },
  computed: {
    ...mapGetters({
      permission: 'Auth/permission'
    }),
    tabHeaders () {
      return [
        {
          id: '1',
          value: 'send',
          title: 'การส่งข้อความ',
          show: this.permission.settingManageMessage
        },
        {
          id: '2',
          value: 'auto-message',
          title: 'ข้อความอัตโนมัติ',
          show: this.permission.settingManageMessage
        },
        {
          id: '3',
          value: 'message',
          title: 'ข้อความคำสั่งซื้อ',
          show: this.permission.settingManageMessage
        },
        {
          id: '4',
          value: 'cod',
          title: 'ข้อความคำสั่งซื้อ COD',
          show: this.permission.settingManageMessage
        }
      ].filter((item) => item.show)
    },
    tab: {
      set (tab) {
        this.$router.push(`/message/${tab}`)
      },
      get () {
        return this.$route.path.split('/')[2]
      }
    }
  }
}
</script>

<style>
  .v-window__container {
    background: #F1F2F5;
  }
</style>
